<template>
  <div class="page-content" id="device-list">
    <Titlebar :incrustation="'fa-mobile-phone'">
      <h1>{{ $t("device.titles.list") }}</h1>
    </Titlebar>

    <UiDrawer v-model="isOpen" :title="$t('users.drawer_title')">
      <!-- icones types de licences -->
      <div style="margin-top: 30px" v-if="useDvFlagAccess('beepiz-licence-can:update')">
        <span
        >{{ $t("users.selectNumber1") }}
          <span style="font-weight: bold">{{ selectedElements.length }}</span>
          {{ $t("users.users") }}</span
        >
      </div>
      <!-- Attribuer un profil -->
      <div style="margin-top: 40px">
        <span
        >{{
            $t("users.attribute")
          }}<span style="font-weight: bold">{{
              $t("device.registrations.profile")
            }}</span>
          {{ $t("users.atUserSelected") }}</span
        >
        <b-form-select
            v-model="licenceProfileSelection"
            style="margin-top: 10px"
            :options="profilesList"
        ></b-form-select>
      </div>
      <!-- Attribuer un groupe -->
      <div style="margin-top: 20px" v-if="useDvFlagAccess('beepiz-group-can:update')">
        <span
        >{{
            $t("users.attribute")
          }}<span style="font-weight: bold">{{
              $t("device.group.group")
            }}</span>
          {{ $t("users.atUserSelected") }}</span
        >
        <b-form-select
            v-model="licenceGroupSelection"
            style="margin-top: 10px"
            :options="groupsList"
        ></b-form-select>
      </div>
      <div style="margin-top: 20px">
        <b-button
            @click="sendUserDatas()"
            :disabled="!(licenceGroupSelection || licenceProfileSelection)"
        >{{ $t("users.validate") }}
        </b-button
        >
      </div>
    </UiDrawer>

    <UiCard>
      <!--Bouton modifier la sélection-->
      <b-button
          size="sm"
          v-if="(useDvFlagAccess('beepiz-licence-can:update') || useDvFlagAccess('beepiz-group-can:update'))"
          :disabled=" selectedElements.length === 0"
          @click="openModification"
          class="mr-2 mb-3"
      >
        {{ $t("users.modify") }} ({{ selectedElements.length }})
      </b-button>

      <div class="row">
        <div class="col col-xl-12">
          <!--Compteur-->
          <div class="mb-3">
            <span v-html="$tc('device.count', count, { count: count })"></span>
          </div>

          <!--Table-->
          <SuperTable
              ref="tableIdentifications"
              :tableColumns="tableColumns"
              :tableData="tableData"
              :loading="loading"
              @sort="handleSort"
              @filter="handleFilter"
              @onSelectAll="handleSelectAll"
              @onSelectRow="handleSelectItem"
          ></SuperTable>
        </div>
      </div>
    </UiCard>

    <!--Footer-->
    <Toolbar>
      <div class="row">
        <div class="col"></div>
        <div class="col center">
          <Pagination ref="pagination" @change="handlePagination"></Pagination>
        </div>
        <div class="col">
          <div class="float-right">
            <Btn
              :class="[{disabled: downloadExport}, 'default']"
              style="margin-left: auto"
              @click.native.prevent="exportDevices()"
            >
              <span
                ><i class="fa fa-download"></i>&nbsp;&nbsp;&nbsp;{{
                  $t("global.download")
                }}</span
              >
              <LoadingMini ref="loading"></LoadingMini>
            </Btn>
          </div>
        </div>
      </div>
    </Toolbar>
  </div>
</template>

<script>
import axios from "axios";
import API from "@/services/API.js";
import Globals from "@/services/globals.js";
import Utils from "@/services/utils.js";
import moment from "moment";
import Titlebar from "@/components/ui/Titlebar";
import Toolbar from "@/components/ui/Toolbar";
import Btn from "@/components/ui/Button";
import UiCard from "@/components/ui/Card";
import Pagination from "@/components/ui/Pagination";
import SuperTable from "@/components/ui/Table";
import PhoneLabelRenderer from "@/components/devices/tableRenderers/DeviceRenderer";
import ProfileRenderer from "@/components/devices/tableRenderers/ProfileRenderer";
import MonitoringRenderer from "@/components/devices/tableRenderers/MonitoringRenderer";
import Association from "@/views/devices/Association";
import LoadingMini from "@/components/ui/LoadingMini";
import picto_standard from "@/assets/img/picto/1_Standard_yellow.svg";
import picto_premium from "@/assets/img/picto/2_Premium_yellow.svg";
import picto_enterprise from "@/assets/img/picto/3_Enterprise_yellow.svg";

import SelectAllRenderer from "@/components/ui/table-renderer/SelectAllRenderer";
import SelectRowRenderer from "@/components/ui/table-renderer/SelectRowRenderer";

import UiDrawer from "@/components/ui/UiDrawer";
import {useDvFlagAccess} from "../../services/featureFlag";

export default {
  name: "DevicesList",
  components: {
    Titlebar,
    Toolbar,
    Btn,
    Pagination,
    SuperTable,
    Association,
    UiCard,
    UiDrawer,
    LoadingMini,
  },
  computed: {
    profilesList() {
      let profilesList = [];
      let firstProposition = {
        value: null,
        text:
            Utils.t("users.select") +
            " " +
            Utils.t("device.registrations.profile"),
      };

      for (let i = 0; i < this.profiles.length; i++) {
        profilesList.push({
          value: this.profiles[i].profileId,
          text: this.profiles[i].meta.name,
        });
      }
      profilesList = [firstProposition, ...profilesList];
      return profilesList;
    },

    groupsList() {
      let groupsList = [];
      let firstProposition = {
        value: null,
        text: Utils.t("users.select") + " " + Utils.t("device.group.group"),
      };

      for (let i = 0; i < this.groups.length; i++) {
        groupsList.push({
          value: this.groups[i].id,
          text: this.groups[i].name,
        });
      }
      groupsList = [firstProposition, ...groupsList];
      return groupsList;
    },
  },
  data: () => ({
    loading: false,
    isOpen: false,
    licenceGroupSelection: null,
    licenceProfileSelection: null,
    profiles: [],
    groups: [],

    selectedElements: [],
    tableData: [],
    downloadExport: false,

    count: 0,
    config: {
      perpage: Globals.perPage,
      fields: [],
      page: 1,
      filter: {
        like: [],
        equals: [],
      },
      sort: ["+name"],
    },
    tableColumns: {
      global: {
        sortable: false,
        noItemsMsg: window.V.$i18n.t("device.emptyTable"),
      },
      columns: [
        {
          key: "action",
          label: SelectAllRenderer,
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: false,
          filter: false,
          renderer: SelectRowRenderer,
          width: "13px",
          minWidth: "13px",
        },
        {
          key: "name",
          label: Utils.t("device.name"),
          showPopup: false,
          activeFilter: "",
          activeSort: "+",
          sortable: true,
          filter: {
            type: "text",
          },
          renderer: PhoneLabelRenderer,
          width: "18%",
        },
        {
          key: "accessory",
          label: Utils.t("device.watch"),
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: false,
          width: "7%",
          renderer: function (item) {
            let ret = '<div style="display: flex; justify-content: center">';

            for (let accessory in item.accessories) {
              ret +=
                  '<span class="size-6 do-svg-full" title="' +
                  Utils.getAccessoryInformation(accessory).label +
                  '">' +
                  Utils.getAccessoryInformation(accessory).logo +
                  "</span>";
            }

            ret += '</div>';
            return ret;
          },
        },
        {
          key: "deviceManufacturer",
          label: Utils.t("device.brand"),
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: true,
          filter: {
            type: "list",
            values: [],
          },
          width: "10%",
        },
        {
          key: "deviceModel",
          label: Utils.t("device.model"),
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: true,
          filter: {
            type: "list",
            values: [],
          },
          width: "10%",
        },
        {
          key: "phoneNumbers",
          label: Utils.t("device.mobile"),
          filter: false,
          width: "10%",
          renderer: function (item) {
            const phoneList = [];
            if (item.slot1PhoneNumber) {
              phoneList.push(item.slot1PhoneNumber);
            }
            if (item.slot2PhoneNumber) {
              phoneList.push(item.slot2PhoneNumber);
            }
            return phoneList.join('<br>');
          },
        },
        {
          key: "groupId",
          label: Utils.t("device.groupSelect"),
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: false,
          width: "10%",
          filter: {
            type: "list",
            values: [],
          },
          renderer: function (item) {
            if (item.group != null) {
              return item.group.name;
            }
            return "";
          },
        },
        {
          key: "profile.name",
          label: Utils.t("device.profile"),
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: true,
          width: "17%",
          filter: {
            type: "text",
          },
          renderer: ProfileRenderer,
        },
        {
          key: "rmStatus",
          label: '<i class="fa fa-bullhorn"></i>',
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: true,
          hide: true,
          width: "6%",
          filter: {
            type: "list",
            values: [
              {
                id: 1,
                label: Utils.t("remoteMonitoring.status.status1"),
              },
              {
                id: 2,
                label: Utils.t("remoteMonitoring.status.status2"),
              },
              {
                id: 3,
                label: Utils.t("remoteMonitoring.status.status3"),
              },
              {
                id: 4,
                label: Utils.t("remoteMonitoring.status.status4"),
              },
            ],
          },
          renderer: MonitoringRenderer,
        },
        {
          key: "id",
          label: Utils.t("device.license"),
          showPopup: false,
          activeFilter: "",
          activeSort: false,
          sortable: true,
          filter: {
            type: "text",
          },
          width: "15%",
          renderer: function (item) {
            var ret =
                '<span class="licence-number">' +
                '<span class="licence-symbol">' +
                '<i class="fa fa-hashtag"></i>' +
                "</span>" +
                '<span class="licence-text">' +
                Utils.pad(item.id, "0", 8) +
                "</span>" +
                "</span>";

            return ret;
          },
        },
        {
          key: "offer",
          label: Utils.t("device.remoteMonitoring"),
          showPopup: false,
          activeSort: false,
          sortable: false,
          hide:true,
          width: "10%",
          style: "height:100%; display:inline-block; width:100%;",

          renderer: function (item) {

            if (item.rmStatus != null && item.rmStatus != 12) {
              return ('<span class="">'+
                  '<i class="option-label fa fa-bullhorn fa-fw" title="' +
                  Utils.t("device.remoteMonitoring") +
                  " télésurveilleur" +
                  '"></i></span>');
            }
          },
        },
      ],
      rowActions: {},
    },
    manufacturerFilter: [],
    modelFilter: [],
  }),

  methods: {
    useDvFlagAccess,
    reloadDatas() {
      this.loadData();
    },
    sendUserDatas() {
      let objectToSend = {
        licenses: this.selectedElements,
        group: this.licenceGroupSelection,
        profile: this.licenceProfileSelection,
      };
      axios
          .post(API.endpoints.datis.assignGroupProfil, objectToSend)
          .then((response) => {
            this.reloadDatas();
            this.resetCheckboxes();
            this.closeModification();
          })
          .catch((error) => {
            this.reloadDatas();
            this.closeModification();
          });
    },
    openModification() {
      if (!this.isOpen) {
        this.isOpen = true;
      }
    },
    closeModification() {
      if (this.isOpen) {
        this.isOpen = false;
      }
    },
    handlePagination(page) {
      this.config.page = page;
      this.loadData();
    },
    handleSort() {
      this.config.sort = [];
      for (var colKey in this.tableColumns.columns) {
        var col = this.tableColumns.columns[colKey];
        if (col.activeSort) {
          this.config.sort.push(col.activeSort + col.key);
        }
      }
      this.loadData();
    },
    handleFilter() {
      this.config.page = 1;
      this.config.filter.like = [];
      this.config.filter.equals = [];
      for (var colKey in this.tableColumns.columns) {
        var col = this.tableColumns.columns[colKey];
        if (col.activeFilter != "") {
          if (col.filter && col.filter.type == "text") {
            this.config.filter.like.push(col.key + ":" + col.activeFilter);
          }
          if (col.filter && col.filter.type == "list") {
            this.config.filter.equals.push(col.key + ":" + col.activeFilter);
          }
        }
      }
      this.loadData();
    },
    loadData: function () {
      this.loading = true;
      axios
          .get(API.endpoints.datis.index + API.constructQueryParams(this.config))
          .then((response) => {
            this.loading = false;
            let tmpData = response.data.data;

            const maxTmpData = tmpData.length;
            for (let i = 0; i < maxTmpData; i++) {
              if (this.selectedElements.includes(tmpData[i].id)) {
                tmpData[i].selected = true;
              } else {
                tmpData[i].selected = false;
              }
            }

            this.tableData = tmpData;

            this.count = response.data.meta.pagination.total;

            if (Object.values(this.tableData).some(licence => licence.options?.[235] != null)) {
              this.tableColumns.columns[8].hide = false;
              this.tableColumns.columns[10].hide = false;
            }

            const manufacturerFilter = Object.values(
                response.data.meta.filters.manufacturer
            )
                .map((manufacturer) => ({id: manufacturer, label: manufacturer}))
                .sort((a, b) => a.label.localeCompare(b.label));
            this.tableColumns.columns[3].filter.values = manufacturerFilter;

            const modelFilter = Object.values(response.data.meta.filters.model)
                .map((model) => ({id: model, label: model}))
                .sort((a, b) => a.label.localeCompare(b.label));
            this.tableColumns.columns[4].filter.values = modelFilter;

            const groupFilter = Object.entries(response.data.meta.filters.group)
                .map(([id, label]) => ({id, label}))
                .sort((a, b) => a.label.localeCompare(b.label));
            this.tableColumns.columns[6].filter.values = groupFilter;

            const profileFilter = Object.entries(
                response.data.meta.filters.profile
            )
                .map(([id, label]) => ({id, label}))
                .sort((a, b) => a.label.localeCompare(b.label));
            this.tableColumns.columns[7].filter.values = profileFilter;

            this.$refs.pagination.update(response.data.meta.pagination);

            if(useDvFlagAccess("beepiz-licence-can:update")){
              axios
                .get(API.endpoints.profiles.index + "?perpage=99999")
                .then((responseProfiles) => {
                  this.profiles = responseProfiles.data.data;
                });

            }
            if(useDvFlagAccess("beepiz-group-can:update")){
              axios
                      .get(API.endpoints.groups.index + "?perpage=99999")
                      .then((responseGroups) => {
                        this.groups = responseGroups.data.data;

                        window.Vfc.$refs.loading.hide();
                      });
            }
          });
    },
    handleSelectAll: function (selectAll) {
      for (let itemIdx in this.tableData) {
        this.tableData[itemIdx].selected = selectAll;
        this.handleSelectItem(this.tableData[itemIdx]);
      }
    },
    handleSelectItem: function (item) {
      if (item.selected && !this.selectedElements.includes(item.id)) {
        this.selectedElements.push(item.id);
      } else if (!item.selected && this.selectedElements.includes(item.id)) {
        this.selectedElements.splice(this.selectedElements.indexOf(item.id), 1);
      }
    },
    exportDevices: function () {
      this.$refs.loading.show();
      this.downloadExport = true

      axios({
          method: 'post',
          url: API.endpoints.datis.export,
          responseType: 'blob',
          headers: {
            'Accept': "application/vnd.ms-excel"
          }
        })
          .then(response => {
            // It is necessary to create a new blob object with mime-type explicitly set
            // otherwise only Chrome works like it should
            var newBlob = new Blob([response.data], {type: "application/vnd.ms-excel"})

            // IE doesn't allow using a blob object directly as link href
            // instead it is necessary to use msSaveOrOpenBlob
            if (window.navigator && window.navigator.msSaveOrOpenBlob) {
              window.navigator.msSaveOrOpenBlob(newBlob, Utils.t('device.datis_export_filename', { date: moment().format("DDMMYYYY") }) + ".xls");
              return;
            }

            // For other browsers:
            // Create a link pointing to the ObjectURL containing the blob.
            const data = window.URL.createObjectURL(newBlob);
            var link = document.createElement('a');
            document.body.appendChild(link);
            link.href = data;
            link.download = Utils.t('device.datis_export_filename', { date: moment().format("DDMMYYYY") });
            link.click();
            setTimeout(function () {
              // For Firefox it is necessary to delay revoking the ObjectURL
              window.URL.revokeObjectURL(data);
            }, 100)
          })
          .catch(error => {
            window.Vfc.$refs.messages.sendMessage('error', window.V.$i18n.t('errors.e500') + ' ' + error);
          })
          .finally(() => {
            this.$refs.loading.hide();
            this.downloadExport = false
          })
    },
  },

  mounted() {
    if (!useDvFlagAccess("beepiz-licence-can:read")) {
      this.$router.push({name: "AccessDenied", params: {slug: "devices"}});
    } else {
      this.loadData();
    }
  },
};
</script>
